jQuery(function ($) {
    "use strict";
    
    // Check if blog filters already initialized to prevent double initialization
    if (window.blogFiltersInitialized) {
        return;
    }
    window.blogFiltersInitialized = true;
    
    let currentCategory = '';
    let currentSort = '';
    let currentPage = 1;
    let isLoading = false;

    // Category filter click - use off/on to prevent duplicate handlers
    $(document).off('click', '.category-filter').on('click', '.category-filter', function() {
        if (isLoading) return;
        
        currentCategory = $(this).data('category');
        currentPage = 1;
        
        // Update active state
        $('.category-filter').removeClass('active border-primary').addClass('border-neutral-400');
        $(this).addClass('active border-primary').removeClass('border-neutral-400');
        
        loadPosts(true);
    });

    // Sort by change
    $('#sort-by').off('change').on('change', function() {
        if (isLoading) return;
        
        currentSort = $(this).val();
        currentPage = 1;
        
        loadPosts(true);
    });

    // Load more button click
    $('#load-more-btn').off('click').on('click', function() {
        if (isLoading) return;
        
        currentPage++;
        loadPosts(false);
    });

    function loadPosts(replace = true) {
        isLoading = true;
        
        // Show loading state
        if (replace) {
            $('#posts-container').css('opacity', '0.5');
        } else {
            $('#load-more-btn').hide();
            $('#loading-spinner').removeClass('hidden');
        }

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'filter_posts',
                category: currentCategory,
                sort: currentSort,
                page: currentPage,
                nonce: ajax_object.nonce
            },
            success: function(response) {
                if (response.success) {
                    const $container = $('#posts-container');
                    
                    if (replace) {
                        // Replace all posts
                        $container.html(response.data.html);
                        $container.data('page', 1);
                        currentPage = 1;
                    } else {
                        // Append new posts - remove duplicates if any
                        const $newPosts = $(response.data.html);
                        const existingIds = [];
                        
                        // Get existing post IDs
                        $container.find('.post-item').each(function() {
                            const href = $(this).attr('href');
                            if (href) existingIds.push(href);
                        });
                        
                        // Filter out duplicates before appending
                        $newPosts.each(function() {
                            const href = $(this).attr('href');
                            if (!existingIds.includes(href)) {
                                $container.append(this);
                            }
                        });
                        
                        $container.data('page', currentPage);
                    }
                    
                    // Update total posts
                    $container.data('total', response.data.total);
                    
                    // Show/hide load more button
                    const totalLoaded = $container.find('.post-item').length;
                    if (totalLoaded >= response.data.total) {
                        $('#load-more-btn').hide();
                    } else {
                        $('#load-more-btn').show();
                    }
                    
                    // Restore opacity
                    $container.css('opacity', '1');
                } else {
                    console.error('Error loading posts');
                }
            },
            error: function() {
                console.error('AJAX request failed');
            },
            complete: function() {
                isLoading = false;
                $('#loading-spinner').addClass('hidden');
            }
        });
    }
});

